import { Diamond } from "@src/types/DiamondDetail";
import { ButtonStyle, OptionStyle } from "./types";

export const typeUpdate = (itemDetail?: Diamond) => {
  return itemDetail?.display_configuration_v2?.map((item) => {
    let selected_item = "";
    if (
      !item.option_visible &&
      !item.option_slug &&
      (item.option_searchable || item.option_required)
    ) {
      selected_item = item?.option_value[0].value;
    } else {
      const slugDetailValue = itemDetail.slug_detail?.[item.option_type];
      if (
        typeof slugDetailValue === "object" &&
        !Array.isArray(slugDetailValue) &&
        slugDetailValue !== null
      ) {
        selected_item = slugDetailValue;
      } else if (Array.isArray(slugDetailValue)) {
        const transformedArray = slugDetailValue.map((slug) =>
          slug
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        );
        selected_item = transformedArray.join(", ");
      } else {
        const slugToMatch =
          typeof slugDetailValue === "string"
            ? slugDetailValue.toLowerCase().replaceAll(" ", "-")
            : "";
        const index = item?.option_value?.findIndex(
          (option_value) =>
            !!option_value.slug &&
            (option_value.slug === slugToMatch ||
              option_value.slug === String(slugDetailValue).toLowerCase() ||
              option_value.value === slugDetailValue)
        );
        selected_item =
          index !== undefined && index >= 0
            ? getSelectedItemValue(item.option_value[index]?.value)
            : "";
      }
    }
    return { ...item, selected_item };
  });
};

const getSelectedItemValue = (value) => {
  if (typeof value === "string") {
    return value;
  } else if (Array.isArray(value)) {
    return value.join(", ");
  } else if (typeof value === "object" && value !== null) {
    return JSON.stringify(value); // Safe string conversion for objects
  } else {
    return "";
  }
};

export const sortAllTypes = (allTypes) => {
  if (!Array.isArray(allTypes)) return [];

  // Create a shallow copy before sorting to avoid mutating frozen array
  const sortedAllTypes = [...allTypes].sort(
    (a, b) => a.option_order - b.option_order
  );

  // Also clone option_value arrays before sorting them
  return sortedAllTypes.map((type) => ({
    ...type,
    option_value: [...type.option_value].sort((a, b) => a.order - b.order),
  }));
};

export function getImageTypeFromUrl(url: string) {
  // grab whatever comes after the last "."
  const ext = url.split(".").pop()?.toLowerCase() ?? "unknown";
  if (ext === "svg") return "svg";
  if (ext === "png") return "png";
  // you can add jpg, webp, etc. here
  return "unknown";
}

export function isObjectWithSelectedSlugs(value) {
  return (
    value !== null &&
    typeof value === "object" &&
    value.hasOwnProperty("selected_slugs")
  );
}

export const buildNestedParams = (
  prefix: string,
  obj: Record<string, string>
): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const key in obj) {
    result[`${prefix}[${key}]`] = obj[key];
  }
  return result;
};

export const fetchComponentSize = (
  style: string
): { buttonSize?: ButtonStyle; showCarousel: boolean } => {
  const arrayString = style.split("-");

  const allButtonStyles = Object.values(ButtonStyle).reduce((acc, value) => {
    acc[value] = value;
    return acc;
  }, {} as Record<string, ButtonStyle>);

  return {
    buttonSize: allButtonStyles[arrayString[1]],
    showCarousel: arrayString[2]
      ? arrayString[2] === "with_carousel"
      : arrayString[0].includes("with_slider") || false,
  };
};

export const isKeyPresent = (key: string, optionError: {}) => {
  return key in optionError;
};

export const isRectangularTextButtonWithPrice = (type: string) => {
  return (
    type === OptionStyle.rectangularTextButtonWithPrice ||
    type === OptionStyle.textButtonWithPriceNoCarousel ||
    type === OptionStyle.textButtonWithPriceWithCarousel
  );
};

export function updateURL(itemId: number) {
  const url = new URL(window.location.href);
  const segments = url.pathname.split("/");

  const itemDetailIndex = segments.findIndex((seg) => seg === "item-detail");
  if (itemDetailIndex !== -1 && segments.length > itemDetailIndex + 1) {
    segments[itemDetailIndex + 1] = itemId.toString();
    url.pathname = segments.join("/");
  }

  if (url.searchParams.has("type")) {
    url.searchParams.delete("type");
  }

  window.history.replaceState(window.history.state, "", url.toString());
}
